import React from 'react'
import './GoTop.css'
import { useState, useEffect } from 'react';
// import { Link, animateScroll as scroll } from "react-scroll";


import { FaAngleUp } from 'react-icons/fa'
const GoTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
        if (window.scrollY > 400) {
            setShowTopBtn(true);
        } else {
            setShowTopBtn(false);
        }
    });
}, []);


const goToTop = () => {
  window.scrollTo({
      top: 0,
      behavior: "smooth",
  });
};
  return (
    <>
    <div className="top-to-btm">
            <FaAngleUp className="icon-position icon-style" onClick={goToTop}/>
        </div>
    </>
  )
  }

  

export default GoTop
